import PosCartActions from '../../../actions/PosCartActions';
import NotificationActions from '../../../actions/NotificationActions';
import PopupActions from '../../../actions/PopupActions';

import UserStore from '../../../stores/UserStore';

import AddWholesale from './AddWholesale.react';
import AddWholesaleBulk from './AddWholesaleBulk.react';
import PromptCouponValue from './PromptCouponValue.react';
import PosCartStore from '../../../stores/PosCartStore';
import AjaxPromises from '../../../utils/AjaxPromises';
import { endPoints as UserEndPoints } from '../../../constants/UserConstants';

class Increase extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            addWholesale        : false,
            addWholesaleBulk    : false,
            promptCouponValue   : false,
            bulk                : false,
            confirmLastFour     : false,
            confirmManagerPin   : false,
            lastFour            : '',
            pinCode             : '',
            amount              : '1',
            loading             : false
        };

        this.incOptions = this.incOptions.bind(this);
        this.confirmLastFour = this.confirmLastFour.bind(this);
        this.confirmManagerPin = this.confirmManagerPin.bind(this);
        this.increase = this.increase.bind(this);
        this.onCartStoreChange = this.onCartStoreChange.bind(this);
        this.isValid = this.isValid.bind(this);
    }

    

    componentWillMount() {
        PosCartStore.addChangeListener(this.onCartStoreChange);
        this.setState({ 
            loading: PosCartStore.getState().loading
        });
    }

    componentDidUpdate() {
        $('.pos-sidebar').css({
            'z-index' : this.state.confirmLastFour ? 1 : 2
        });

        $('.pos-sidebar').css({
            'z-index' : this.state.confirmManagerPin ? 1 : 2
        });
    }

    componentWillUnmount() {
        PosCartStore.removeChangeListener(this.onCartStoreChange);

        $('.pos-sidebar').css({ 'z-index' : 2 });
    }

    onCartStoreChange() {
        
        let loading = PosCartStore.getState().loading;
       
        this.setState({ 
            loading
        });
    }

    isValid() {
        //I hate this logic, but if TotalAvailable is undefined that's valid too
        return (this.props.item && !(this.props.item.TotalAvailable <= 0)) && !this.state.loading;
    }

    async isItemExpired(item) {
        let payload = {
            serialNumbers: [item.SerialNo],
        };

        let resp = await AjaxPromises.POST('api/v2/inventory/get-expired-inventory-items', UserStore.getApiData(payload));
        if(resp.Result) {
            if (resp.Data.length > 0) {
                return true
            } else {
                return false
            }
        }
    }

    async incOptions() {
        var item     = this.props.item;
        var page     = this.props.page;
        var location = UserStore.getState().selectedLocation;

        var promptQty = location.ShowUnitCountToAdd;

        if(!this.isValid()){
            return;
        }

        if (promptQty && (item.ProductType === 'Qty' || item.WgtCnt === 'Qty') && page === 'search') {
            this.setState({ addWholesale : true }, () => {
                $('#last-four').focus().select();
            });
        } else if (promptQty && (item.ProductType === 'Wgt' || item.WgtCnt === 'Wgt') && page === 'search') {
            this.setState({ addWholesaleBulk : true }, () => {
                $('#last-four').focus().select();
            });
        } else if (location.Last4 && (item.CannabisInventory === 'Yes' || item.CannbisProduct === 'Yes')) {
            this.setState({ confirmLastFour : true }, () => {
                $('#last-four').focus();
            });
        } else if (location.CheckExpirationDate) {
            if(await this.isItemExpired(item)) {
                this.setState({ confirmManagerPin : true }, () => {
                    $('#manager-pin').focus();
                });
            } else {
                this.increase();
            }
        } else {
            this.increase();
        }
    }

    confirmLastFour() {
        var self = this;

        var item = this.props.item;
        var lastFour = this.state.lastFour;

        if (item.SerialNo.length >= 4 && item.SerialNo.substr(item.SerialNo.length - 4) == lastFour) {
            this.setState({ confirmLastFour : false, lastFour : '' }, () => {
                self.increase();
            });
        } else {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'SerialNo is not matching',
            });
        }
    }

    confirmManagerPin() {
        var formData = UserStore.getApiData();
        formData.PinCode = this.state.pinCode;

        if (!UserStore.getApiData().Register) {
            NotificationActions.addNotification({
                type : 'error',
                body : 'Please select a register before continuing',
            });

            return;
        }

        AjaxPromises.POST(UserEndPoints.CHECK_PIN_NUMBER,
            formData).then(res => {
                if (res.Result && res.Data[0].MgrPermission === true) {
                    this.setState({ confirmManagerPin : false, pinCode : '' }, () => {
                        this.increase();
                    });
                } else {
                    NotificationActions.addNotification({ type : 'alert', body : 'Invalid PIN' });
                }
            }
        );
    }
    
    increase() {
        var item = this.props.item;

        if (!this.isValid())
            return;

        if (item.ProductType === 'Qty' || item.WgtCnt === 'Qty') {

            var tmpItem = item;
            if (!tmpItem.hasOwnProperty('UnitPrice')) {
                tmpItem.UnitPrice = tmpItem.TotalCost / tmpItem.QtyAllocated;
            }

            tmpItem.PackageItemId = null;
            PosCartActions.addItemToCart(tmpItem, this.props.guest, this.state.amount)
        } else if ((item.ProductType === 'Wgt' || item.WgtCnt === 'Wgt'))
            PopupActions.addBulk(this.props.guest, item);
    }

    render() {
        var self = this;

        var item      = this.props.item;
        var guest     = this.props.guest;
        var page      = this.props.page;
        
        if(this.props.hide) {
            return null;
        }
        
        if (guest.IsPaid) {
            return null;
        }

        var className = this.isValid() ? '' : 'btn-green__disabled'; //  || item.WgtCnt === 'Wgt'
        
        return (
            <div className={'increase '+(this.props.page === 'search' ? 'increase__search' : '')}>
                <div
                    className={'increase__btn '+className}
                    onClick={this.incOptions}>

                    { this.state.loading ? <i className='fa fa-spinner fa-spin' aria-hidden='true' /> : <i className='fa fa-plus' aria-hidden='true' /> }
                </div>

                { this.state.confirmLastFour &&
                    <div className='popup popup__transparent'>
                        <div className='popup__content increase__last-four'>
                            <div className='popup-header'>
                                LAST 4 DIGITS

                                <div
                                    className='popup-close'
                                    onClick={() => { self.setState({ confirmLastFour : false, lastFour : '' }); }}>

                                    <i className='fa fa-times' aria-hidden='true' />
                                </div>
                            </div>

                            <input
                                type='text'
                                id='last-four'
                                value={this.state.lastFour}
                                onChange={(e) => { this.setState({ lastFour : e.target.value }); }} />

                            <div
                                className='increase__last-four--go'
                                onClick={this.confirmLastFour}>

                                OK
                            </div>
                        </div>

                    </div>
                }

                { this.state.confirmManagerPin &&
                    <div className='popup popup__transparent'>
                        <div className='popup__content increase__last-four'>
                            <div className='popup-header'>
                                Add Expired Item

                                <div
                                    className='popup-close'
                                    onClick={() => { self.setState({ confirmManagerPin : false, pinCode : '' }); }}>

                                    <i className='fa fa-times' aria-hidden='true' />
                                </div>
                            </div>

                            <input
                                type='password'
                                id='manager-pin'
                                value={this.state.pinCode}
                                placeholder='Manager PIN'
                                onChange={(e) => { this.setState({ pinCode : e.target.value }); }} />

                            <div
                                className='increase__last-four--go'
                                onClick={this.confirmManagerPin}>
                                OK
                            </div>
                        </div>

                    </div>
                }

                { this.state.addWholesale &&
                    <AddWholesale
                        item={item}
                        guest={guest}
                        onClose={() => { self.setState({ addWholesale : false }); }} />
                }

                { this.state.addWholesaleBulk &&
                    <AddWholesaleBulk
                        item={item}
                        guest={guest}
                        onClose={() => { self.setState({ addWholesaleBulk : false }); }} />
                }

                { this.state.promptCouponValue &&
                    <PromptCouponValue
                        item={item}
                        guest={guest}
                        onClose={() => { self.setState({ promptCouponValue : false }); }} />
                }
            </div>

        );
    }
}

export default Increase;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/selected/Increase.react.jsx